import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { AgmCoreModule } from '@agm/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns'; 

import { ToastrModule } from 'ngx-toastr';
import { PipesModule } from './theme/pipes/pipes.module';

import { AppRoutingModule } from './app.routing';
import { AppSettings } from './app.settings';

import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { HeaderComponent } from './theme/components/header/header.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { SidebarComponent } from './theme/components/sidebar/sidebar.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { BackTopComponent } from './theme/components/back-top/back-top.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
//import { ApplicationsComponent } from './theme/components/applications/applications.component';
//import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
// import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
// import { SideChatComponent } from './theme/components/side-chat/side-chat.component';
// import { FavoritesComponent } from './theme/components/favorites/favorites.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './services/loading/loading.interceptor';
import { HomeModule } from './home/home.module';
import { ViewCollectionMasterComponent } from './pages/Collection_Master/view-collection-master/view-collection-master.component';
import { AddUserCollectionComponent } from './pages/User-Collection/add-user-collection/add-user-collection.component';
import { ViewUserCollectionComponent } from './pages/User-Collection/view-user-collection/view-user-collection.component';

import { AddUserPostComponent } from './pages/User-Post/add-user-post/add-user-post.component';
import { ViewUserPostComponent } from './pages/User-Post/view-user-post/view-user-post.component';
import { NgxSpinnerModule } from 'ngx-spinner';
//import { AddUserAdminComponent } from './pages/User-Admin-Master/add-user-admin/add-user-admin.component';
//import { ViewUserAdminComponent } from './pages/User-Admin-Master/view-user-admin/view-user-admin.component';
//import { AddTryeUserDetailsComponent } from './pages/Trye-User-Details/add-trye-user-details/add-trye-user-details.component';
//import { ViewTryeUserDetailsComponent } from './pages/Trye-User-Details/view-trye-user-details/view-trye-user-details.component';
//import { AddTruckMasterComponent } from './pages/Trye-Master/add-truck-master/add-truck-master.component';
//import { ViewTruckMasterComponent } from './pages/Trye-Master/view-truck-master/view-truck-master.component';
//import { AddTruckComponent } from './pages/Trye-Master/add-truck/add-truck.component';
//import { ViewTruckComponent } from './pages/Trye-Master/view-truck/view-truck.component';
//import { ViewSizeComponent } from './pages/Trye-Master/view-size/view-size.component';
//import { ViewApplicationComponent } from './pages/Trye-Master/view-application/view-application.component';
//import { ViewBrandComponent } from './pages/Trye-Master/view-brand/view-brand.component';
//mport { AddTryeComponent } from './pages/add-trye/add-trye.component';
//import { ViewTryeComponent } from './pages/view-trye/view-trye.component';
// import { ProductsComponent } from './pages/products/products.component';
// import { AddAppProductsComponent } from './pages/app-products/add-app-products/add-app-products.component';
// import { ViewAppProductsComponent } from './pages/app-products/view-app-products/view-app-products.component';
// import { GroupDetailsModule } from './group-details/group-details.module';
// import { AddGroupDetailsComponent } from './add-group-details/add-group-details.component';
// import { ViewGroupDetailsComponent } from './view-group-details/view-group-details.component';
// import { AddGroupDetail1Component } from './add-group-detail1/add-group-detail1.component';
// import { AddGroupDetails1Component } from './add-group-details1/add-group-details1.component';
// import { ViewGroupDetailsComponent } from './pages/Group-Details/view-Group-Details/view-group-details/view-group-details.component';
// import { AddGroupDetailsComponent } from './pages/Group-Details/add-group-details/add-group-details.component';
// import{ViewGroupDetailsModule} from './pages/group-details2/view-group-details/view-group-details.module'
// import { AddGroupDetailsModule } from './pages/group-details2/add-group-details/add-group-details.module';
// import { AddGroupDetailModule } from './pages/Group-Details/add-group-details/add-group-detail.module';
// import { viewGroupDetailModule } from './pages/Group-Details/view-Group-Details/view-group-details.module';
// import { AddGroupDetailsModule } from './pages/group-details2/add-group-details/add-group-details.module';
// import { ViewGroupDetailsRoutingModule } from './pages/group-details2/view-group-details/view-group-details-routing.module';


@NgModule({  
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    PerfectScrollbarModule,
    NgbModule,
    MultiselectDropdownModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAO7Mg2Cs1qzo_3jkKkZAKY6jtwIlm41-I'
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    ToastrModule.forRoot(), 
    PipesModule,
    AppRoutingModule,
    HttpClientModule,
    HomeModule,
    NgxSpinnerModule,
    // GroupDetailsModule
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    BreadcrumbComponent,
    BackTopComponent,
    FullScreenComponent,
    // ApplicationsComponent,
    // MessagesComponent,
    UserMenuComponent,
    //FlagsMenuComponent,
    //SideChatComponent,
   
    BlankComponent,
    //SearchComponent,
    NotFoundComponent,
    //AddUserPostComponent,
    //ViewUserPostComponent,
    //ViewUserPostComponent,
    //AddUserCollectionComponent,
    //ViewUserCollectionComponent,
    //ViewCollectionMasterComponent,
    // AddCSIMasterComponent,
    // ViewCSIMasterComponent,
    //AddUserAdminComponent,
    //ViewUserAdminComponent,
    //AddTryeUserDetailsComponent,
    //ViewTryeUserDetailsComponent,
    //AddTruckMasterComponent,
    //ViewTruckMasterComponent,
    //AddTruckComponent,
    //ViewTruckComponent,
    //ViewSizeComponent,
    //ViewApplicationComponent,
    //ViewBrandComponent,
    //AddTryeComponent,
    //ViewTryeComponent,
    // ProductsComponent,
    // AddAppProductsComponent,
    // ViewAppProductsComponent,
   

    // AddGroupDetailsComponent,
    // ViewGroupDetailsComponent,
    // AddGroupDetail1Component,
    // AddGroupDetails1Component,
    // ViewGroupDetailsComponent,
    // AddGroupDetailModule,
    // viewGroupDetailModule,
    // viewGroupDetailModule 
    // AddGroupDetailsModule,
    // ViewGroupDetailsRoutingModule
   
    

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }, 
    AppSettings,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { } 